// @flow strict
import styled from "styled-components";

const Name = styled.h1`
  margin: 0.3rem 1rem 0 0 !important;
`;

export default Name;
